import { render, staticRenderFns } from "./Joules.vue?vue&type=template&id=f1866bf4&"
import script from "./Joules.vue?vue&type=script&lang=js&"
export * from "./Joules.vue?vue&type=script&lang=js&"
import style0 from "./Joules.vue?vue&type=style&index=0&id=f1866bf4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports